export default "__VITE_ASSET__7ufqBeYI__"